// Janelas de preferência da OS — 5 períodos.
// Espelho de services/agend-core/src/lib/janelaPreferencia.js
// (mantém os dois arquivos em sincronia se mudar algum período).

export const JANELAS = [
  { id: 'manha_1', label: '1º período manhã', range: '08:00-10:00', icone: '🌅' },
  { id: 'manha_2', label: '2º período manhã', range: '10:00-12:00', icone: '🌤️' },
  { id: 'tarde_1', label: '1º período tarde', range: '13:00-15:00', icone: '☀️' },
  { id: 'tarde_2', label: '2º período tarde', range: '15:00-17:00', icone: '🌇' },
  { id: 'tarde_3', label: '3º período tarde', range: '17:00-19:00', icone: '🌆' },
];

export function labelJanela(id) {
  const j = JANELAS.find(x => x.id === id);
  if (j) return `${j.icone} ${j.label} (${j.range})`;
  if (id === 'manha')    return '🌅 Manhã (08-12)';
  if (id === 'tarde')    return '☀️ Tarde (13-18)';
  if (id === 'qualquer') return '⏰ Qualquer horário';
  return id || '—';
}
